// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination_paginationRoot__JHsQD {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.pagination_pageGroup__2zOUs {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.28rem;
  padding: 0.35rem 0.4rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 2px 8px rgba(15, 23, 42, 0.05);
}

.pagination_page__sZkkA {
  min-width: 2.35rem;
  height: 2.35rem;
  padding: 0 0.45rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9375rem;
  font-weight: 600;
  font-family: inherit;
  letter-spacing: -0.02em;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition:
    background-color 0.12s ease,
    border-color 0.12s ease,
    color 0.12s ease,
    box-shadow 0.12s ease,
    transform 0.08s ease;
}

.pagination_page__sZkkA:hover:not(:disabled):not(.pagination_pageActive__UgtM9):not(.pagination_pageEllipsis__jKvof) {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

.pagination_page__sZkkA:active:not(:disabled):not(.pagination_pageActive__UgtM9):not(.pagination_pageEllipsis__jKvof) {
  transform: scale(0.96);
}

.pagination_page__sZkkA:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.35);
}

.pagination_pageActive__UgtM9 {
  color: #ffffff !important;
  background: var(--pagination-accent, #4A4DBB) !important;
  border-color: var(--pagination-accent, #4A4DBB) !important;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
}

.pagination_pageActive__UgtM9:hover:not(:disabled) {
  filter: brightness(1.06);
}

.pagination_pageEllipsis__jKvof {
  background: transparent !important;
  border-color: transparent !important;
  color: #94a3b8 !important;
  font-weight: 700;
  letter-spacing: 0;
  cursor: default;
  min-width: 1.85rem;
  pointer-events: none;
  box-shadow: none !important;
}

.pagination_pageEllipsis__jKvof:focus-visible {
  box-shadow: none !important;
}

.pagination_arrowBtn__t\\+kqo {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  padding: 0;
  color: #64748b;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 2px 6px rgba(15, 23, 42, 0.04);
  transition:
    background-color 0.12s ease,
    border-color 0.12s ease,
    color 0.12s ease,
    transform 0.08s ease;
}

.pagination_arrowBtn__t\\+kqo:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #334155;
}

.pagination_arrowBtn__t\\+kqo:active:not(:disabled) {
  transform: scale(0.96);
}

.pagination_arrowBtn__t\\+kqo:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.3);
}

.pagination_arrowBtn__t\\+kqo:disabled {
  opacity: 0.32;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/ajonjolib/utils/pagination/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;;oCAEkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB;;;;;wBAKsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,wDAAwD;EACxD,0DAA0D;EAC1D,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf;;oCAEkC;EAClC;;;;wBAIsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".paginationRoot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.pageGroup {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.28rem;\n  padding: 0.35rem 0.4rem;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 2px 8px rgba(15, 23, 42, 0.05);\n}\n\n.page {\n  min-width: 2.35rem;\n  height: 2.35rem;\n  padding: 0 0.45rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  font-family: inherit;\n  letter-spacing: -0.02em;\n  color: #475569;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  user-select: none;\n  transition:\n    background-color 0.12s ease,\n    border-color 0.12s ease,\n    color 0.12s ease,\n    box-shadow 0.12s ease,\n    transform 0.08s ease;\n}\n\n.page:hover:not(:disabled):not(.pageActive):not(.pageEllipsis) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.page:active:not(:disabled):not(.pageActive):not(.pageEllipsis) {\n  transform: scale(0.96);\n}\n\n.page:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.35);\n}\n\n.pageActive {\n  color: #ffffff !important;\n  background: var(--pagination-accent, #4A4DBB) !important;\n  border-color: var(--pagination-accent, #4A4DBB) !important;\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);\n}\n\n.pageActive:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n\n.pageEllipsis {\n  background: transparent !important;\n  border-color: transparent !important;\n  color: #94a3b8 !important;\n  font-weight: 700;\n  letter-spacing: 0;\n  cursor: default;\n  min-width: 1.85rem;\n  pointer-events: none;\n  box-shadow: none !important;\n}\n\n.pageEllipsis:focus-visible {\n  box-shadow: none !important;\n}\n\n.arrowBtn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  padding: 0;\n  color: #64748b;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 2px 6px rgba(15, 23, 42, 0.04);\n  transition:\n    background-color 0.12s ease,\n    border-color 0.12s ease,\n    color 0.12s ease,\n    transform 0.08s ease;\n}\n\n.arrowBtn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #334155;\n}\n\n.arrowBtn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.arrowBtn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.3);\n}\n\n.arrowBtn:disabled {\n  opacity: 0.32;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationRoot": `pagination_paginationRoot__JHsQD`,
	"pageGroup": `pagination_pageGroup__2zOUs`,
	"page": `pagination_page__sZkkA`,
	"pageActive": `pagination_pageActive__UgtM9`,
	"pageEllipsis": `pagination_pageEllipsis__jKvof`,
	"arrowBtn": `pagination_arrowBtn__t+kqo`
};
export default ___CSS_LOADER_EXPORT___;
